export default function CoverageSummaryBar({ summary }) {
  return (
    <div className="flex gap-6 text-sm">
      <Stat label="Datasets" value={summary.datasets_total} />
      <Stat label="Full" value={summary.full} color="text-green-400" />
      <Stat label="Partial" value={summary.partial} color="text-yellow-400" />
      <Stat label="None" value={summary.none} color="text-red-400" />
    </div>
  );
}

function Stat({ label, value, color = "text-white" }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-muted">{label}:</span>
      <span className={`font-semibold ${color}`}>{value}</span>
    </div>
  );
}